const enToEs: Record<string, string> = {
  "/": "/es/",
  "/sliding-door-repair/": "/es/reparacion-puertas-corredizas/",
  "/glass-replacement/": "/es/reemplazo-de-vidrios/",
  "/window-hardware-repair/": "/es/reparacion-herrajes-ventanas/",
  "/weatherstripping-sealing/": "/es/burletes-y-sellado/",
  "/window-cleaning-maintenance/": "/es/limpieza-y-mantenimiento/",
  "/emergency-board-up/": "/es/tapiado-de-emergencia/",
  "/service-areas/": "/es/areas-de-servicio/",
  "/reviews/": "/es/historias/",
  "/blog/": "/es/blog/",
  "/blog/window-repair-cost-miami/": "/es/blog/costo-reparacion-ventanas-miami/",
  "/blog/impact-windows-vs-shutters/": "/es/blog/ventanas-impacto-vs-persianas/",
  "/blog/insurance-discount-impact-windows/": "/es/blog/descuento-seguro-ventanas-impacto/",
  "/blog/hvhz-code-noa-explained/": "/es/blog/codigo-hvhz-noa-explicado/",
  "/impact-windows-brickell/": "/es/ventanas-impacto-brickell/",
  "/impact-windows-aventura/": "/es/ventanas-impacto-aventura/",
  "/impact-windows-miami-beach/": "/es/ventanas-impacto-miami-beach/",
  "/impact-windows-coral-gables/": "/es/ventanas-impacto-coral-gables/",
  "/impact-windows-coconut-grove/": "/es/ventanas-impacto-coconut-grove/",
  "/impact-windows-doral/": "/es/ventanas-impacto-doral/",
  "/impact-windows-kendall/": "/es/ventanas-impacto-kendall/",
  "/impact-windows-pinecrest/": "/es/ventanas-impacto-pinecrest/",
  "/impact-windows-bay-harbor-islands/": "/es/ventanas-impacto-bay-harbor-islands/",
  "/impact-windows-key-biscayne/": "/es/ventanas-impacto-key-biscayne/",
  "/impact-windows-south-miami/": "/es/ventanas-impacto-south-miami/",
  "/impact-windows-north-miami-beach/": "/es/ventanas-impacto-north-miami-beach/",
  "/privacy-policy/": "/es/politica-de-privacidad/",
  "/terms-of-service/": "/es/terminos-de-servicio/",
  "/legal-disclaimer/": "/es/aviso-legal/",
  "/accessibility/": "/es/accesibilidad/"
};

const esToEn: Record<string, string> = {};
Object.entries(enToEs).forEach(([en, es]) => {
  esToEn[es] = en;
});

function normalizePath(path: string): string {
  let p = path;
  if (!p.endsWith("/")) p = p + "/";
  return p;
}

export function getTranslatedRoute(currentPath: string, targetLang: "en" | "es"): string {
  const normalized = normalizePath(currentPath);

  if (targetLang === "es") {
    return enToEs[normalized] ?? `/es${normalized}`;
  }

  return esToEn[normalized] ?? normalized.replace(/^\/es\//, "/");
}